import React, { useRef, useCallback, useImperativeHandle, useState, useLayoutEffect, forwardRef } from 'react';
import Style from './FJAutoTextarea.module.less';
import FJUtil from '../../../util/FJUtil';

const FJAutoTextarea = (props, ref) => {
    const {
        text = '',
        onChange,
        onSplit,
        mergePrev,
        onTextareaBlur,
        onDelete,
        placeholder = '',
        maxLength = 5000,
    } = props;

    const _textareaRef = useRef(null);
    const _autoTextRef = useRef(null);
    const [value, setValue] = useState('');

    useImperativeHandle(ref, () => {
        return {
            focus: (cursorPosition = 0) => {
                _textareaRef.current.focus();
                if (cursorPosition !== -1) {
                    _textareaRef.current.selectionStart = cursorPosition;
                    _textareaRef.current.selectionEnd = cursorPosition;
                }
            },
            blur: () => {
                _textareaRef.current.blur();
            },
        };
    });

    useLayoutEffect(() => {
        const lastStr = text.slice(text.length - 1, text.length);
        // 最后一个字符为换行符的时候，div的高度不会包含最后的一行
        if (lastStr === '\n') {
            setValue(text + '#');
        } else {
            setValue(text);
        }
        _textareaRef.current.value = text;
    }, [text]);
    const _selectAll = useCallback(() => {
        _textareaRef.current.select();
    }, [_textareaRef.current]);

    const _onKeyDown = useCallback(
        e => {
            if (e.keyCode === 13) {
                if (e.shiftKey) {
                    // 换行  不需要做任何事， （如果需要支持其他快捷键则需要以下代码）
                    // setValue(e.target.value + '\n' + '#');
                    // _textareaRef.current.value = _textareaRef.current.value + '\n';
                } else {
                    e.preventDefault();
                    // 分割/新建字幕 手动回车算一个位置
                    // console.log(value,value.length, e.target.selectionStart, e)
                    _textareaRef.current.blur();
                    onSplit && onSplit(e.target.selectionStart);
                }
            }

            // back 按钮
            if (e.keyCode === 8) {
                // 该行字幕合并到上一行
                if (e.target.selectionStart === 0 && e.target.selectionEnd === 0) {
                    if (e.target.value !== '') {
                        mergePrev && mergePrev();
                    } else {
                        onDelete && onDelete();
                    }
                }
            }

            // delete 按钮处理
            if (e.keyCode === 46 && e.target.value === '') {
                onDelete && onDelete();
            }

            // ctrl + a
            if ((e.metaKey || e.ctrlKey) && 65 === e.keyCode) {
                _selectAll();
            }
        },
        [value, mergePrev, onSplit, _selectAll],
    );
    const _onChange = useCallback(
        FJUtil.throttle(e => {
            onChange(e.target.value);
        }, 50),
        [value],
    );

    return (
        <div className={Style.box}>
            <textarea
                className={Style.textarea}
                placeholder={placeholder}
                onKeyDown={_onKeyDown}
                onChange={_onChange}
                ref={_textareaRef}
                onBlur={onTextareaBlur}
                maxLength={maxLength}
            />
            <div className={Style.auto_box} ref={_autoTextRef}>
                {value}
            </div>
        </div>
    );
};

export default forwardRef(FJAutoTextarea);
